<img [src]="getAsset(ageCategory)" [class]="class" [alt]="getAlt(ageCategory) | translate">
